import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/Input.scss';

export default function Input({
    className,
    ...props
}) {
    const classes = classNames(styles.input, className);
    return (
        <input {...props} className={classes} />
    );
}

Input.propTypes = {
    className: PropTypes.string,
};
